import TagManager from "react-gtm-module";

const { REACT_APP_ENV } = process.env;

const EVENTS = {
  BUY_GEO: "BuyGeo",
  CONNECT_WALLET: "Connect Wallet",
  STAKING: "Staking",
};

const sendEvent = ({ event, category, label, value = "value" }) => {
  if (REACT_APP_ENV === "production") {
    const args = {
      dataLayer: {
        event,
        event_category: category,
        event_label: label,
        value,
      },
    };

    TagManager.dataLayer(args);
  }
};

export const sendBuyGeoEvent = (label) =>
  sendEvent({
    event: EVENTS.BUY_GEO,
    category: "Purchase",
    label,
  });

export const sendConnectWalletEvent = (label) =>
  sendEvent({
    event: EVENTS.CONNECT_WALLET,
    category: "Wallet",
    label,
  });

export const sendStakeEvent = (category) =>
  sendEvent({
    event: EVENTS.STAKING,
    category,
    label: "Confirmation",
  });
